import styled from 'styled-components';

export const SubjectDescription = styled.div`
    font-size: .7rem;
    max-width: 600px;
`;